/**
 * Seed collections shown to unauthenticated (guest) users when their local
 * snapshot is empty, so the app is not blank on first launch.
 */
export const GUEST_DEMO_COLLECTIONS = [
  {
    id: 'demo-collection',
    name: 'Demo Collection',
    requests: [
      {
        id: 'demo-request-1',
        name: 'Get JSONPlaceholder Posts',
        method: 'GET',
        url: 'https://jsonplaceholder.typicode.com/posts/1',
        headers: [{ key: 'Content-Type', value: 'application/json', enabled: true }],
        params: [{ key: '', value: '', enabled: true }],
        body: '',
        bodyType: 'json',
      },
      {
        id: 'demo-request-2',
        name: 'Create New Post',
        method: 'POST',
        url: 'https://jsonplaceholder.typicode.com/posts',
        headers: [{ key: 'Content-Type', value: 'application/json', enabled: true }],
        params: [{ key: '', value: '', enabled: true }],
        body:
          '{\n  "title": "My New Post",\n  "body": "This is the post content",\n  "userId": 1\n}',
        bodyType: 'json',
      },
    ],
  },
];
